<script lang="ts" setup>
  import {computed} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import CpButtonIcon from '~/components/cp/CpButtonIcon/CpButtonIcon.vue';

  const likeValue = defineModel<number>('likeValue', {required: true});
  const dislikeValue = defineModel<number>('dislikeValue', {required: true});
  const kind = defineModel<'enabled'|'votedThumbsUp'|'votedThumbsDown'|'disabled'>('kind', {required: true});
  const voted = defineModel<boolean>('voted', {default: false});

  const emit = defineEmits({
    thumbUp: null,
    thumbDown: null,
  });

  const likeType = computed(() => {
    return kind.value === 'enabled' ?
      'primary' :
      kind.value === 'votedThumbsUp' ? 'secondary' : 'neutral';
  });

  const dislikeType = computed(() => {
    return kind.value === 'enabled' ?
      'primary' :
      kind.value === 'votedThumbsDown' ? 'secondary' : 'neutral';
  });

  function emitter(value: boolean) {
    if (!voted.value && kind.value !== 'disabled') {
      voted.value = true;
      if (value) {
        emit('thumbUp');
        likeValue.value++;
      } else {
        emit('thumbDown');
        dislikeValue.value++;
      }
    }
  }

  const {b, e} = useCpBem('cp-thumb-rate');
</script>

<template>
    <div :class="b">
        <div
            :class="e`thumb`"
            :data-testid="kind === 'votedThumbsDown' ? 'cp-thumb-rate__thumb-dislike-disabled' : 'cp-thumb-rate__thumb-dislike'"
        >
            <CpText :type="dislikeType" variant="caption-bold">
                {{ dislikeValue }}
            </CpText>
            <CpButtonIcon :type="dislikeType" kind="voted_off" @click="emitter(false)" />
        </div>
        <div
            :class="e`thumb`"
            :data-testid="kind === 'votedThumbsUp' ? 'cp-thumb-rate__thumb-like-disabled' : 'cp-thumb-rate__thumb-like'"
        >
            <CpText variant="caption-bold" :type="likeType">
                {{ likeValue }}
            </CpText>
            <CpButtonIcon :type="likeType" kind="voted_on" @click="emitter(true)" />
        </div>
    </div>
</template>
<style scoped lang="scss">
  .cp-thumb-rate {
    display: flex;
    flex-direction: row;
    gap: var(--cp-gutter-small);
    &__thumb {
      display: flex;
      gap: var(--cp-gutter-xsmall);
      align-items: center;
    }
  }
</style>
